import React from "react";
import Search from "../Search";
import PickedContent from "../PickedContent";
import Logo from "../../pictures/logo.png";

const Home = () => {
    return (<div>
        <img className="ui centered medium image" alt="STAGED" src={Logo}/>
        <Search/>
        <PickedContent/>
    </div>)
};

export default Home;